<div class="add-note-templates-dialog">
  <div>
    <span>Attachment Deleting Justification</span>
  </div>
  <div class="import-dialog-content">
    <owc-input appearance="outline" [formControl]="addJustification" required></owc-input>
  </div>
  <div class="import-dialog-actions">
    <owc-button class="cancel-button" (click)="cancelClicked()">
      Cancel
    </owc-button>
    <owc-button color="primary" [disabled]="addJustification.value==''" (click)="saveJustification()">
      Delete
    </owc-button>
  </div>
</div>